import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../utilities/LogErrors'
import { Loading } from './../../Common/Loading'
import { Header } from './../../Header/V2/Header'

import { GetCurrentCenter as BLGetCurrentCenter, GetNickname as BLGetNickname, ResetGroupToShow } from './../../../utilities/BL/Navigation'
import { DeleteInstructorProgressData } from './../../../utilities/BL/Sessions'

import { BodyWithSideMenu } from './../BodyWithSideMenu'
import { WEBPAGES } from './../../../utilities/EL/WebPages'
import { HELP_TYPE } from './../../../utilities/EL/HelpType'
import { TYPE_PROPOSITION_VALUE } from './../../../utilities/EL/TypePropositionValue'
import { ROLES } from './../../../utilities/EL/Roles'


const Leader = ({ theme, setTheme }) => {
    const navigate = useNavigate()
    
    const [isLoading, setIsLoading] = useState(true)
    const [theTheme] = useState(theme)

    const [currentCenter, setCurrentCenter] = useState(null)
    const [nickname, setNickname] = useState(null)


    const LoadPage = async () => {
        try {
            document.body.classList.add('BodyComplete')


            const response = await BLGetCurrentCenter()
            
            if (response.success) {
                let centerId = response?.data?.id

                if (!centerId) {
                    return
                }

                // Si el dato viene como cadena, convertirlo a entero
                if (typeof centerId === "string") {
                    centerId = parseInt(centerId)
                }
                
                response.data.id = centerId

                setCurrentCenter(response.data)
            }
 

            // Obtener info del alias del usuario para utilizar cierta info en la pantalla
            const responseNickname = await BLGetNickname()
            
            if (responseNickname.success) {
                const nickname = responseNickname?.data

                if (!nickname) {
                    return
                }

                setNickname(nickname)
            }
        } catch (error) {
            await LogErrors('LoadPage - Leader', error)
        } finally {
            setIsLoading(false)
        }
    }

    /**
     * Función para obtener la configuración, una vez que termine de cargarse el componente
     */
    useEffect(() => {
        LoadPage()
    }, []) // El array vacío [] asegura que useEffect se ejecute solo una vez, al montar


    return (
        isLoading ? (
            <Loading />
        ) : (
            <BodyWithSideMenu page={WEBPAGES.LEADER.DASHBOARD} theme={theme} propositionValue={TYPE_PROPOSITION_VALUE.LEADER} idHelp={HELP_TYPE.LEADER.DASHBOARD} role={ROLES.LEADER} >
                <Header theme={theme} setTheme={setTheme} propositionValue={TYPE_PROPOSITION_VALUE.LEADER} idHelp={HELP_TYPE.LEADER.DASHBOARD} />

                <main className='container Dashboard--V2 Container-FullHeight Fonts--PlusJakartaSans'>
                    <p className='Dashboard--V2__Title'>Bienvenid@ <span className='Dashboard--V2__Text--Highlight'>{(nickname && nickname !== '') && ` ${nickname}`}</span></p>
                    {currentCenter?.name && (
                        <p className='Dashboard--V2__Text Dashboard--V2__Text--Small Dashboard--V2__Text--Hide'>Centro: {currentCenter.name}</p>
                    )}
                    <p className='Dashboard--V2__SpaceUp'>Ingresa a la opción que desees</p>

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        {/* <p className='Dashboard--V2__Sections__Title'>Secciones</p> */}

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray'> {/* onClick={() => navigate('/leader/instructors')} */}
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-people Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Mis instructores</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Visualiza y consulta a tus instructores, accede a la información de su perfil y gestiona acciones esenciales.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'> {/* onClick={() => navigate('/leader/instructors')} */}
                                    {/* <i className='bi bi-arrow-right'></i> */}
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div>

                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray'> {/* onClick={() => navigate('/leader/groups')} */}
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-arrow-left-right Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Mover grupos</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Selecciona un grupo y asígnalo a otro instructor, reorganiza la distribución según las necesidades de tu centro.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'> {/* onClick={() => navigate('/leader/groups')} */}
                                    {/* <i className='bi bi-arrow-right'></i> */}
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div>

                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray'> {/* onClick={() => navigate('/leader/licenses')} */}
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-files Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Licencias Ztudia</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Selecciona un grupo y asígnalo a otro instructor, reorganiza la distribución según las necesidades de tu centro.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'> {/* onClick={() => navigate('/leader/licenses')} */}
                                    {/* <i className='bi bi-arrow-right'></i> */}
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div>

                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray'> {/* onClick={() => navigate('/leader/certificates')} */}
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-stickies Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Generar constancias</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Genera constancias de forma individual o en bloque, aplica filtros por instructor o grupo y descarga los documentos oficiales.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'> {/* onClick={() => navigate('/leader/certificates')} */}
                                    {/* <i className='bi bi-arrow-right'></i> */}
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className='Dashboard--V2__SpaceUp Dashboard--V2__Sections'>
                        <p className='Dashboard--V2__Sections__Title'>Reportes</p>

                        <div className='Dashboard--V2__Sections__List'>
                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray'> {/* onClick={() => navigate('/leader/reports')} */}
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-list-check Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Resultados de los Ztudiantes</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consulta los resultados de las evaluaciones de todos los Ztudiantes de tu centro, analiza el desempeño aplicando filtros y exporta reportes académicos.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'> {/* onClick={() => navigate('/leader/reports')} */}
                                    {/* <i className='bi bi-arrow-right'></i> */}
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div>

                            <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray'> {/* onClick={() => navigate('/leader/progress')} */}
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-bar-chart Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Progreso de los Ztudiantes</p>

                                    <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                        <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Consulta el avance de todos los Ztudiantes de tu centro, visualiza el progreso que han tenido con su instructor y da seguimiento académico.</li>
                                    </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons'> {/* onClick={() => navigate('/leader/progress')} */}
                                    {/* <i className='bi bi-arrow-right'></i> */}
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div>

                            {/* <div className='Dashboard--V2__Sections__List__Items--Instructor Dashboard--V2__Sections__List__Items--Gray' onClick={() => navigate('/leader/ztudents')}>
                                <div>
                                    <figure className='Dashboard--V2__Sections__List__Items--Instructor__Icon'>
                                        <i className='bi bi-bar-chart-fill Dashboard--V2__Sections__List__Items--Instructor__Icon__Item'></i>
                                    </figure>

                                    <p className='Dashboard--V2__Sections__List__Items--Instructor__Title'>Espacio de Ztudiantes</p>

                                    // <ul className='Dashboard--V2__Sections__List__Items--Instructor__DetailList'>
                                    //     <li className='Dashboard--V2__Sections__List__Items--Instructor__DetailList__Items'>Descripción...</li>
                                    // </ul>
                                </div>

                                <button type='button' className='Btn__Ztudia--PrimaryOutline Dashboard--V2__Sections__List__Items--Instructor__Buttons' onClick={() => navigate('/leader/ztudents')}>
                                    // <i className='bi bi-arrow-right'></i>
                                    <i className='bi bi-lock'></i>
                                </button>
                            </div> */}
                        </div>
                    </section>
                </main>
            </BodyWithSideMenu>
        )
    )
}

export { Leader };